import Bat from "./Bat";
import common from "../../common";

export default class FlockController {

    static distance(v0, v1) {
        return Math.sqrt((v0.x - v1.x) * (v0.x - v1.x) + (v0.y - v1.y) * (v0.y - v1.y));
    }

    get target() {
        return this._target;
    }

    set target(value) {
        this._target = value;
    }

    set targeting(value) {
        this._options.targeting = value; // duplicating value in settings object to ovoid misleading when logging settings
        this._targeting = value;
    }

    constructor(container, options = {
        limits: {velocity: 620, force: 20},
        weights: {s: 1.1, a: 0.9, c: 1, t: 1.1},
        separation: 60,
        sense: 100,
        targeting: true,
        wrapAround: false,
        bounds: null
    }) {

        /*
        const options = {
            limits: {velocity: 620, force: 20},
            weights: {s: 1.1, a: 0.9, c: 1, t: 1.1},
            separation: 60,
            sense: 100,
            targeting: true,
            wrapAround: false
        };
         */

        this._bounds = options.bounds;

        this._options = options;

        this._flockContainer = container;
        this._boids = [];

        this._target = new PIXI.Point();

        this._maxVelocity = this._options.limits.velocity;
        this._maxForce = this._options.limits.force;

        this._wrapAround = this._options.wrapAround;
        this._targeting = this._options.targeting;

        /*
        const sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        sprite.anchor.set(0.5);
        this._flockContainer.addChild(sprite);

        this._flockContainer.interactive = true;
        this._flockContainer.hitArea = new PIXI.Rectangle(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this._flockContainer.mousedown = (event) => {
            this._target = event.data.getLocalPosition(this._flockContainer);
            sprite.position = this._target.clone();
        }
        */
    }

    populate(length) {
        for (let i = 0; i < length; i++) {
            const boid = new Bat();
            boid.position = this._target.clone();
            boid.x += P3.math.randomInt(-4, 4);
            boid.y += P3.math.randomInt(-4, 4);

            this._flockContainer.addChild(boid);
            this._boids.push(boid);
        }
    }

    wake() {
        for (let i = 0; i < this._boids.length; i++) {
            this._boids[i].sleeping = false;
        }
    }

    update(dt) {
        for (let i = 0; i < this._boids.length; i++) {
            const boid = this._boids[i];
            if (!boid.sleeping)
                this._flock(boid);

            boid.update(dt);

            this._wrapAround && this._wrap(boid);
            this._bounds && this._bound(boid);
        }
    }

    _wrap(boid) {
        if (boid.x < -boid.width * 0.5) boid.x = common.STAGE_WIDTH + boid.width * 0.5;
        if (boid.y < -boid.height * 0.5) boid.y = common.STAGE_HEIGHT + boid.height * 0.5;
        if (boid.x > common.STAGE_WIDTH + boid.width * 0.5) boid.x = -boid.width * 0.5;
        if (boid.y > common.STAGE_HEIGHT + boid.height * 0.5) boid.y = -boid.height * 0.5;
    }

    _bound(boid) {
        if (boid.x < this._bounds.x - boid.width * 0.5) {
            boid.velocity.x = -boid.velocity.x * 1.01;
            boid.x = this._bounds.x - boid.width * 0.5;
        }
        if (boid.y < this._bounds.y - boid.height * 0.5) {
            boid.velocity.y = -boid.velocity.y * 1.01;
            boid.y = this._bounds.y - boid.height * 0.5
        }
        if (boid.x > this._bounds.x + this._bounds.width + boid.width * 0.5) {
            boid.velocity.x = -boid.velocity.x * 1.01;
            boid.x = this._bounds.x + this._bounds.width + boid.width * 0.5;
        }
        if (boid.y > this._bounds.y + this._bounds.height + boid.height * 0.5) {
            boid.velocity.y = -boid.velocity.y * 1.01;
            boid.y = this._bounds.y + this._bounds.height + boid.height * 0.5;
        }
    }

    _flock(boid) {
        // calculate forces
        const sep = this._separation(boid);
        const ali = this._alignment(boid);
        const coh = this._cohesion(boid);

        // scale forces by weights
        const weights = this._options.weights
        sep.scaleBy(weights.s);
        ali.scaleBy(weights.a);
        coh.scaleBy(weights.c);

        // add these to boids velocity;
        boid.velocity.incrementBy(sep);
        boid.velocity.incrementBy(ali);
        boid.velocity.incrementBy(coh);

        // seek target point
        if (this._targeting) {
            const targetSeek = this._seek(this._target, boid);
            targetSeek.scaleBy(weights.t);
            boid.velocity.incrementBy(targetSeek);
        }
    }

    _seek(target, boid) {
        target = new P3.math.Vector2(target.x, target.y); // convert to vector2

        const desired = target.subtract(boid.position).normalize().scale(this._maxVelocity);

        return desired.subtract(boid.velocity).truncate(this._maxForce);
    }

    _separation(boid) {
        const desiredSeparation = this._options.separation;
        const steer = new P3.math.Vector2();

        let count = 0;
        for (let i = 0; i < this._boids.length; i++) {
            const other = this._boids[i];
            // if (other === boid)
            //     continue;

            const d = Math.max(FlockController.distance(boid.position, other.position), 0);

            if (d > 0 && d < desiredSeparation) {
                const displacement = new P3.math.Vector2(boid.x, boid.y).subtract(other.position).normalize();
                steer.incrementBy(displacement.scale(1 / d)); // divide by distance (distance weighting)
                count++;
            }

        }

        if (count > 0) {
            steer.scaleBy(1 / count); // average
        }

        if (steer.length > 0) {
            steer.normalize();
            steer.scaleBy(this._maxVelocity);
            steer.set(steer.x - boid.velocity.x, steer.y - boid.velocity.y); // subtract boids velocity (steering)
            steer.truncate(this._maxForce);
        }

        return steer;
    }

    _alignment(boid) {
        const neighborDistance = this._options.sense;
        const sum = new P3.math.Vector2();

        let count = 0;
        for (let i = 0; i < this._boids.length; i++) {
            const other = this._boids[i];
            //   if (other === boid)
            //      continue;

            const d = Math.max(FlockController.distance(boid.position, other.position), 0);

            if (d > 0 && d < neighborDistance) {
                sum.incrementBy(other.velocity);
                count++;
            }
        }

        if (count > 0) {
            sum.normalize();
            sum.scaleBy(this._maxVelocity);
            return sum.subtract(boid.velocity).truncate(this._maxForce);
        } else {
            return new P3.math.Vector2();
        }
    }

    _cohesion(boid) {
        const neighborDistance = this._options.sense;
        const sum = new P3.math.Vector2();

        let count = 0;
        for (let i = 0; i < this._boids.length; i++) {
            const other = this._boids[i];
            // if (other === boid)
            //    continue;

            const d = Math.max(FlockController.distance(boid.position, other.position), 0);

            if (d > 0 && d < neighborDistance) {
                sum.incrementBy(other.position);
                count++;
            }
        }

        if (count > 0) {
            sum.scaleBy(1 / count); // average the position
            return this._seek(sum, boid); // seek average position
        } else {
            return new P3.math.Vector2();
        }
    }

}